import React from 'react';
import { Outlet } from "react-router-dom";
import { Box } from "../components/styled/Elements";
import MainHeader from "../components/header/MainHeader";
import styled from "styled-components";
import NavSidebar from '../components/sidebar/NavSidebar';
import RightSidebar from '../components/sidebar/RightSidebar';


const MainLayout = () =>{
    return (
        <LayoutWrapper className="d-flex center-main">
            <MainHeader />
            <Box className="flex-1 w-100">
                <Box className={"flex-1 custom-scroll content-main"}>
                    <Box className="content-inner">
                        <NavSidebar />
                        <MainContent>
                            <Outlet />
                        </MainContent>
                        <RightSidebar />
                    </Box>
                </Box>
            </Box>
        </LayoutWrapper>
    );
}

export default MainLayout;

const LayoutWrapper = styled.div`
  .content-main{
    padding: 88px 24px 4px 24px;
    .content-inner{
        display: flex;
        width: 100%;
        max-width: 1499px;
        margin-left: auto;
        margin-right: auto;
        height: 100%;
        gap: 16px;
        /* overflow: hidden; */
        padding-bottom: 20px;
    }
  }
  @media (max-width: 767px) {
    .content-main{
        padding-left: 0;
        padding-right: 0;
    }
  }

`;
const MainContent = styled.div`
    width: 100%;
	height: 100%;
	position: relative;
	z-index: 190;
    /* background-color: var(--white); */
    border-radius: 10px;
    position: relative;
	/* box-shadow: 0px 0px 5px rgba(0, 0, 0, .1); */
    
`
